:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._mobileWizardSingleStep_13rtz_7 ._stepHeaderWrapper_13rtz_7 {
  padding: 18px 24px 24px 24px;
  box-sizing: border-box;
  text-align: center; }
  ._mobileWizardSingleStep_13rtz_7 ._stepHeaderWrapper_13rtz_7 ._stepHeader_13rtz_7 {
    padding-bottom: 4px;
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis; }
  ._mobileWizardSingleStep_13rtz_7 ._stepHeaderWrapper_13rtz_7 ._stepSubHeader_13rtz_16 {
    min-height: 48px; }

._mobileWizardSingleStep_13rtz_7 ._mobileWizardThumbnails_13rtz_19 {
  justify-content: center;
  max-width: 444px;
  min-width: 430px;
  margin: auto; }
